import React from "react";
import {
  Box,
  Card,
  Typography,
  Stack,
  Grid,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  useTheme,
  Button,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz"; // أيقونة النقل
import DivideOrderModal from "../OrderActions/DivideOrderModal";
import EditOrderFormCaptinOrder from "../OrderActions/EditOrderFormCaptinOrder";
import EditOrderFormClint from "../OrderActions/EditOrderFormClint";
import EditOrderFormTableNumber from "../OrderActions/EditOrderFormTableNumber";
import { alpha } from "@mui/material/styles";
import { useSettings } from "../../../../../../../../context/SettingsContext";
import { changeOrderStatusApi } from "../../../../../../../../services/OrderStatus/OrderStatusApi";
  import { usePermissions } from "../../../../../../../../context/PermissionsAndFeatures/UserPermissionsContext";


const OrderInfoCard = ({ details, onEdit, onDelete, tables = [] }) => {
  const customer = details.customer || {};
  const theme = useTheme();

  // جلب الإعدادات وتحديد تفضيل عرض رقم الطلب
  const { settings, loading, error } = useSettings();

  // خريطة ترجمة الحالات إلى العربية
  const statusLabels = {
    under_review: "قيد المراجعه",
    pending: "طلب مفتوح",
    open: "مفتوح",
    closed: "مغلق",
    completed: "مكتمل",
    cancelled: "ملغي",
    "اوردر خارجي": "اوردر خارجي",
    "order_under_review": "قيد المراجعه",
    // أضف حالات أخرى عند الحاجة
  };

  // حالة محلية لحفظ الحالة الحالية وعرضها فوراً بعد التأكيد
  const [currentStatus, setCurrentStatus] = React.useState(details.status || "");
  // مزامنة إذا تغيرت الخاصية من الخارج
  React.useEffect(() => {
    setCurrentStatus(details.status || "");
  }, [details.status]);

  // علامة هل الحالة قيد المراجعة (تعتمد الآن على الحالة المحلية)
  const isUnderReview = (currentStatus === "under_review" || currentStatus === "order_under_review");

  // تحديد طريقة ترقيم الفاتورة بناءً على الإعدادات من الـ API
  const orderNumberPreference = settings?.invoice_incremant || "general_increment";
  const { hasPermission } = usePermissions();
  

  const getOrderNumber = () => {
    const map = {
      general: { key: "general_increment", label: "عام" },
      daily: { key: "daily_increment", label: "يومي" },
      monthly: { key: "monthly_increment", label: "شهري" },
      general_increment: { key: "general_increment", label: "عام" },
      daily_increment: { key: "daily_increment", label: "يومي" },
      monthly_increment: { key: "monthly_increment", label: "شهري" },
    };
    const cfg = map[orderNumberPreference] || map.general;
    return { value: details[cfg.key] ?? "-", label: cfg.label };
  };

  // تحويل الوقت إلى نظام 12 ساعة (مثال: "14:30" => "2:30 م")
  const formatTime12 = (timeStr) => {
    if (!timeStr) return "-";
    const parts = timeStr.split(":");
    const h = Number(parts[0] ?? 0);
    const m = parts[1] ?? "00";
    const ampm = h >= 12 ? "م" : "ص";
    const hour12 = h % 12 || 12;
    return `${hour12}:${m} ${ampm}`;
  };

  // state for actions menu
  const [menuAnchor, setMenuAnchor] = React.useState(null);
  const handleMenuOpen = (e) => setMenuAnchor(e.currentTarget);
  const handleMenuClose = () => setMenuAnchor(null);

  const [divideOpen, setDivideOpen] = React.useState(false);
  const [editCaptainOpen, setEditCaptainOpen] = React.useState(false);
  const [editCaptainData, setEditCaptainData] = React.useState(null);

  const [editClientOpen, setEditClientOpen] = React.useState(false);
  const [editClientData, setEditClientData] = React.useState(null);

  const [editTableOpen, setEditTableOpen] = React.useState(false);
  const [editTableData, setEditTableData] = React.useState(null);
  // حالات تأكيد الـ under_review
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const [confirmSuccess, setConfirmSuccess] = React.useState(false);
  const [confirmError, setConfirmError] = React.useState("");
  // anchor للـ menu الذي يتيح اختيار الحالة عند التأكيد
  const [confirmMenuAnchor, setConfirmMenuAnchor] = React.useState(null);

  const handleConfirm = async (status) => {
    if (!details?.id) return;
    try {
      setConfirmMenuAnchor(null);
      setConfirmLoading(true);
      await changeOrderStatusApi(details.id,);
      // تحديث الواجهة محلياً لعرض الحالة الجديدة فوراً
      setCurrentStatus(status);
      setConfirmSuccess(true);
      if (typeof window.refreshOrderDetails === "function") {
        window.refreshOrderDetails(details.id);
      }
    } catch (err) {
      console.error(err);
      setConfirmError("فشل في تأكيد الطلب. حاول مرة أخرى.");
    } finally {
      setConfirmLoading(false);
    }
  };

  return (
    <Card
      sx={{
        borderRadius: 3,
        background: `linear-gradient(135deg, #232334 60%, #1976d2 100%)`,
        color: "#fff",
        p: { xs: 1.5, sm: 2 },
        position: "relative",
        // إخفاء الاسكرول بار للكارت
        overflow: "auto",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
        minHeight: 130,
        mb: 1,
      }}
    >
      {/* أيقونة الإجراءات أعلى الكارت */}
      <Box
        sx={{
          position: "absolute",
          top: 16,
          left: 16,
          zIndex: 2,
          bgcolor: alpha("#232334", 0.85),
          borderRadius: "50%",
          boxShadow: "0 2px 12px #0005",
        }}
      >
        <Tooltip title="إجراءات" arrow>
          <IconButton
            size="medium"
            onClick={handleMenuOpen}
            sx={{
              bgcolor: "#1976d2",
              color: "#fff",
              "&:hover": { bgcolor: "#EA7C69", color: "#fff" },
              boxShadow: 3,
              transition: "all 0.2s",
              width: 44,
              height: 44,
            }}
          >
            <MoreVertIcon fontSize="medium" />
          </IconButton>
        </Tooltip>
        <Menu
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          sx={{
            "& .MuiMenu-paper": {
              borderRadius: 3,
              minWidth: 180,
              boxShadow: "0 8px 32px #23233455",
              bgcolor: "#fff",
              color: "#232334",
              ...(theme.palette.mode === "dark" && {
                bgcolor: "#232334",
                color: "#fff",
              }),
            },
            "& .MuiMenuItem-root": {
              fontWeight: 600,
              fontSize: 15,
              px: 2,
              py: 1.2,
              borderRadius: 2,
              transition: "all 0.15s",
              "&:hover": {
                bgcolor: "#EA7C69",
                color: "#fff",
                "& .MuiSvgIcon-root": { color: "#fff" },
              },
            },
          }}
        >

         {hasPermission("orders_tables_edite_table") && (

          <MenuItem
            onClick={() => {
              handleMenuClose();
              setEditClientData({
                ...details,
                table_id: details.table?.id ?? "",
                order_id: details.id,
                error: "❌ فشل في تعديل الأوردر: ",
              });
              setEditClientOpen(true);
            }}
          >
            <EditIcon sx={{ color: "#1976d2", mr: 1 }} fontSize="small" />
            تعديل بيانات العميل
          </MenuItem>
          )}
          {hasPermission("orders_tables_edite_captain_table") && (
          <MenuItem
            onClick={() => {
              handleMenuClose();
              setEditCaptainData({
                ...details,
                table_id: details.table?.id ?? "",
                delivery_id: details.delivery_id,
                order_id: details.id,
                customer_id: details.customer?.id ?? "",
                error: "❌ فشل في تعديل الأوردر: ",
              });
              setEditCaptainOpen(true);
            }}
          >
            <EditIcon sx={{ color: "#1976d2", mr: 1 }} fontSize="small" />
            تعديل الطيار
          </MenuItem>
          )}

          {hasPermission("orders_tables_delete_table") && (
          <MenuItem
            onClick={() => {
              handleMenuClose();
              onDelete(details.id);
            }}
            sx={{
              color: "#ff4d4f",
              fontWeight: 700,
              "& .MuiSvgIcon-root": { color: "#ff4d4f !important" },
              "&:hover": {
                bgcolor: "#ff4d4f",
                color: "#fff",
                "& .MuiSvgIcon-root": { color: "#fff !important" },
              },
            }}
          >
            <DeleteIcon sx={{ mr: 1 }} fontSize="small" />
            حذف الطلب
          </MenuItem>
          )}
        </Menu>
      </Box>

      <Grid container spacing={2} sx={{ mt: 0.5 }}>
        {/* بيانات العميل */}
        <Grid item xs={12} sm={6}>
          <Stack
            spacing={1.2}
            alignItems="flex-start"
            sx={{
              bgcolor: alpha("#232334", 0.18),
              borderRadius: 3,
              p: 2,
              minHeight: 120,
              boxShadow: "0 2px 8px #23233411",
            }}
          >
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{
                color: "#EA7C69",
                letterSpacing: 0.5,
                mb: 0.5,
                textShadow: "0 1px 4px #0003",
                fontSize: 20,
              }}
            >
              طاولة {details.table?.name || "-"}
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 600, color: "#fff" }}>
              <strong>العميل:</strong> {customer.name || "-"}
            </Typography>
            <Typography
              variant="body2"
              sx={{ opacity: 0.92, color: "#b0bec5" }}
            >
              <strong>هاتف:</strong> {customer.phone1 || "-"}
            </Typography>
            <Typography
              variant="body2"
              sx={{ opacity: 0.92, color: "#b0bec5" }}
            >
              <strong>الطيار:</strong> {details.captain_order?.name || "-"}
            </Typography>
          </Stack>
        </Grid>

        {/* حالة الطلب وباقي التفاصيل */}
        <Grid item xs={12} sm={6}>
          <Stack
            spacing={1.2}
            alignItems="flex-end"
            sx={{
              bgcolor: alpha("#1976d2", 0.1),
              borderRadius: 3,
              p: 2,
              minHeight: 120,
              boxShadow: "0 2px 8px #1976d211",
            }}
          >
            <Box sx={{ height: 18 }} />
            <Typography
              variant="caption"
              sx={{ color: "#b0bec5", fontWeight: 600 }}
            >
              {(() => {
                const num = getOrderNumber();
                return `رقم الطلب (${num.label}): #${num.value}`;
              })()}
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "#b0bec5", fontWeight: 600 }}
            >
              {details.date} - {formatTime12(details.open_time)}
            </Typography>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <FiberManualRecordIcon
                sx={{
                  color: isUnderReview ? "#ff7043" : "limegreen",
                  fontSize: 13,
                  filter: isUnderReview ? "drop-shadow(0 6px 12px rgba(255,112,67,0.22))" : "none",
                }}
              />
              <Typography
                variant="caption"
                sx={{
                  color: isUnderReview ? "#fff" : "#b9f6ca",
                  fontWeight: 700,
                  px: isUnderReview ? 1 : 0,
                  py: isUnderReview ? "2px" : 0,
                  borderRadius: 1,
                  background: isUnderReview ? "linear-gradient(90deg,#ff6b6b 0%,#ff8a65 100%)" : "transparent",
                  boxShadow: isUnderReview ? "0 8px 24px rgba(255,107,107,0.18)" : "none",
                  animation: isUnderReview ? "pulseStatus 1.6s infinite" : "none",
                }}
              >
                {isUnderReview ? "قيد المراجعه" : (statusLabels[currentStatus] || currentStatus || "جاهز للتقديم")}
              </Typography>
              {/* زر التأكيد البارز يظهر فقط عندما تكون الحالة قيد المراجعة */}
              {isUnderReview && (
                <>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={(e) => setConfirmMenuAnchor(e.currentTarget)}
                    disabled={confirmLoading}
                    sx={{
                      ml: 1,
                      bgcolor: "linear-gradient(90deg,#ff8a65 0%,#ff6b6b 100%)",
                      color: "#fff",
                      fontWeight: 800,
                      boxShadow: "0 8px 26px rgba(255,112,67,0.22)",
                      borderRadius: 1.2,
                      px: 1.2,
                      "&:hover": { filter: "brightness(0.95)" },
                    }}
                  >
                    {confirmLoading ? <CircularProgress size={14} color="inherit" /> : "تأكيد"}
                  </Button>

                  <Menu
                    anchorEl={confirmMenuAnchor}
                    open={Boolean(confirmMenuAnchor)}
                    onClose={() => setConfirmMenuAnchor(null)}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                    transformOrigin={{ vertical: "top", horizontal: "left" }}
                  >
                    <MenuItem
                      onClick={() => handleConfirm("pending")}
                      disabled={confirmLoading}
                    >
                     تاكيد كـ "طلب مفتوح"
                    </MenuItem>
            
                  </Menu>
                </>
              )}
            </Stack>
          </Stack>
        </Grid>
      </Grid>

      <DivideOrderModal
        open={divideOpen}
        onClose={() => setDivideOpen(false)}
        orderId={details.id}
        items={details.items || []}
        onSuccess={() => setDivideOpen(false)}
      />
      <EditOrderFormCaptinOrder
  open={editCaptainOpen}
  onClose={(updated) => {
    setEditCaptainOpen(false);
    if (updated && typeof window.refreshOrderDetails === "function") {
      window.refreshOrderDetails(editCaptainData.order_id);
    }
  }}
  initialData={editCaptainData}
/>

      <EditOrderFormClint
        open={editClientOpen}
        onClose={(updated) => {
          setEditClientOpen(false);
          if (updated && typeof window.refreshOrderDetails === "function") {
            window.refreshOrderDetails(editClientData.order_id);
          }
        }}
        initialData={editClientData}
      />

      <EditOrderFormTableNumber
        open={editTableOpen}
        onClose={(updated) => {
          setEditTableOpen(false);
          if (updated && typeof window.refreshOrderDetails === "function") {
            window.refreshOrderDetails(editTableData.order_id);
          }
        }}
        initialData={editTableData}
        tables={tables} // ✅ هنا مررت الطاولات
      />

      {/* إضافات الأنيميشن للـ status */}
      <style>
        {`
          @keyframes pulseStatus {
            0% { transform: scale(1); box-shadow: 0 6px 18px rgba(255,107,107,0.12); }
            50% { transform: scale(1.03); box-shadow: 0 10px 30px rgba(255,107,107,0.28); }
            100% { transform: scale(1); box-shadow: 0 6px 18px rgba(255,107,107,0.12); }
          }
        `}
      </style>

      {/* Snackbar لنجاح/فشل تأكيد القيد */}
      <Snackbar
        open={confirmSuccess}
        autoHideDuration={3000}
        onClose={() => setConfirmSuccess(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="success" sx={{ bgcolor: "#e8f5e9", color: "#2e7d32" }}>
          ✅ تم تأكيد الطلب بنجاح
        </Alert>
      </Snackbar>
      <Snackbar
        open={Boolean(confirmError)}
        autoHideDuration={4000}
        onClose={() => setConfirmError("")}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="error" sx={{ bgcolor: "#ffebee", color: "#c62828" }}>
          {confirmError}
        </Alert>
      </Snackbar>
    </Card>
  );
};

export default OrderInfoCard;
